// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import ElementController from './element_controller'
import AsyncSelectController from './async_select_controller'
import TooltipController from './tooltip_controller'
import TabsController from './tabs_controller'
import ScrollTopController from './scroll_top_controller'
import UploadFileController from './upload_file_controller'
import AutoSubmitController from './auto_submit_contoller'
import CustomOptionController from './custom_option_controller'
import ConfettiController from './confetti_controller'
import RecorderController from './recorder_controller'
import AutogrowTextareaController from './autogrow_textarea_controller'
import ScrollToFirstErrorController from './scroll_to_first_error_controller'
import CheckMinLengthController from './check_min_length_controller'
import LinksNewTabController from './links_new_tab_controller'
import FormResponsesTableController from './form_responses_table_controller'

application.register('element', ElementController)
application.register('async-select', AsyncSelectController)
application.register('tooltip', TooltipController)
application.register('tabs', TabsController)
application.register('scroll-top', ScrollTopController)
application.register('upload-file', UploadFileController)
application.register('auto-submit', AutoSubmitController)
application.register('custom-option', CustomOptionController)
application.register('confetti', ConfettiController)
application.register('recorder', RecorderController)
application.register('autogrow-textarea', AutogrowTextareaController)
application.register('scroll-to-first-error', ScrollToFirstErrorController)
application.register('check-min-length', CheckMinLengthController)
application.register('links-new-tab', LinksNewTabController)
application.register('form-responses-table', FormResponsesTableController)
